export default __webpack_public_path__ + "static/team-medellin-two-273f10c023ac7ccf9621ba422f9f5ca0.jpg";